export const getMealPriceByBox = (prices: any[], box: any): any => {
  if (!prices || prices.length === 0) return null

  const boxId = box.boxId
  const boxType = `BOX_${boxId}`
  const mealBoxPrice = prices.find(price => price.type === boxType)

  return mealBoxPrice ?? null
}
